export const isVianovaHost = window.location.hostname.includes("vianova.it");
export const isVianovaCustomer = (code) => code === "C569051565";
